import { useContext } from "react";

import { TokenContext } from "../../contexts";

export const useToken = () => {
	return useContext(TokenContext);
};
